import { VChip } from 'vuetify/lib/components/VChip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value !== undefined)?_c(VChip,{staticClass:"justify-center pa-0",staticStyle:{"width":"32px"},attrs:{"label":"","color":_vm.color}},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_c('div',{staticClass:"grey--text caption"},[_vm._v(" N/A ")])}
var staticRenderFns = []

export { render, staticRenderFns }